import { Backdrop, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { INPUT_BORDER_FOCUS, PROFILE_FONT } from "../../constants/layout";

const AppLoader = ({ loading }: { loading: boolean }) => {
  return (
    <Backdrop
      open={loading}
      sx={{
        position: "fixed",
        zIndex: 99999,
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(241, 235, 235, 0.72)",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <CircularProgress size={44} sx={{ color: INPUT_BORDER_FOCUS }} />
      <Typography
        sx={{
          mt: 2,
          fontFamily: PROFILE_FONT,
          fontSize: 14,
          fontWeight: 500,
          color: INPUT_BORDER_FOCUS,
        }}
      >
        Loading...
      </Typography>
    </Backdrop>
  );
};

export default AppLoader;
